const prod = {
  url: {
    // API_URL: "http://82.180.160.159:3002",
    // API_URL: "http://92.205.28.214:3002",
    // API_URL: "http://82.180.160.159:3020",
    API_URL: "https://devapi.tenacious-tracker.com",
    // API_URL: "http://82.180.160.159:8080/trackapp",
    // API_URL: "https://api.tenacious-tracker.com",
    CHAT_URL: 'https://api-chatbot.tenacious-tracker.com'
    // CHAT_URL: 'http://82.180.160.159:7000'
  },
  x_version: true
};
const dev = {
  url: {
    // API_URL: "https://api.tenacious-tracker.com", // LIVE WITH DOMAIN
    // API_URL: "http://92.205.28.214:3002",
    // API_URL: "http://82.180.160.159:8080/trackapp", // LIVE WITH IP
    // API_URL: "http://82.180.160.159:3020",
    // API_URL: "https://api.tenacious-tracker.com",
    // API_URL: "http://82.180.160.159:3002",
    API_URL: "https://devapi.tenacious-tracker.com",
    // CHAT_URL: 'https://api-chatbot.tenacious-tracker.com'
    // CHAT_URL: 'http://82.180.160.159:7000'
    CHAT_URL: `http://92.205.28.214:7111`
  },
  x_version: false

};
const { x_version } = window as any
export const newOnboarding = true
export const isUnderMaintenance = false
export const config = process.env.NODE_ENV === "development" ? dev : prod;
export const xVersion = x_version as any;
export const baseEndpoints = {
  createUser: `${config.url.API_URL}/api/v1/app/create-user`,
  passcodeVerify: `${config.url.API_URL}/api/v1/passcode/verify`,
  userLogin: `${config.url.API_URL}/api/v1/app/user-login`,
  emailVerify: `${config.url.API_URL}/api/v1/app/email-verify`,
  addLevel: `${config.url.API_URL}/api/v1/app/add-level`,
  outcome: `${config.url.API_URL}/api/v1/outcome`,
  outcomeSearch: `${config.url.API_URL}/api/v1/outcome-suggestion/search`,
  outcomeSuggestion: `${config.url.API_URL}/api/v1/outcome-suggestion`,
  influence: `${config.url.API_URL}/api/v1/influence`,
  notification: `${config.url.API_URL}/api/v1/notification`,
  influenceSearch: `${config.url.API_URL}/api/v1/influence-suggestion/search`,
  influenceSuggestion: `${config.url.API_URL}/api/v1/influence-suggestion`,
  reflective: `${config.url.API_URL}/api/v1/reflective`,
  reflectiveSearch: `${config.url.API_URL}/api/v1/reflective-suggestion/search`,
  signupcompleted: `${config.url.API_URL}/api/v1/app/mixpanel/events-track`,
  mixPanelHome: `${config.url.API_URL}/api/v1/app/mixpanel/home`,
  reflectiveSuggestion: `${config.url.API_URL}/api/v1/reflective-suggestion`,
  trackingOutcome: `${config.url.API_URL}/api/v1/outcome-response`,
  trackingInfluence: `${config.url.API_URL}/api/v1/influence-response`,
  updateCategoryImage: `${config.url.API_URL}/api/v1/category/update-image`,
  journey: `${config.url.API_URL}/api/v1/journey`,
  tracking: `${config.url.API_URL}/api/v1`,
  userProfile: `${config.url.API_URL}/api/v1/app`,
  category: `${config.url.API_URL}/api/v1/category`,
  categorySuggestion: `${config.url.API_URL}/api/v1/category-suggestion`,

  getImage: `${config.url.API_URL}/api/v1/app/read-file`,
  getFaq: `${config.url.API_URL}/api/v1/faq`,
  feature: `${config.url.API_URL}/api/v1/feature`,
  bug: `${config.url.API_URL}/api/v1/bug`,
  feedback: `${config.url.API_URL}/api/v1/feedback`,

  //reminder
  reminderCreate: `${config.url.API_URL}/api/v1/reminder/create`,
  reminderList: `${config.url.API_URL}/api/v1/reminder/list`,
  

  //setuser
  setProfileImage: `${config.url.API_URL}/api/v1/app/update-profile-image`,
  setUserInfo: `${config.url.API_URL}/api/v1/app/update-profile`,

  //setgoals
  outComeGoals: `${config.url.API_URL}/api/v1/outcome-goal/get`,
  goalsMenu: `${config.url.API_URL}/api/v1/journey/get-goals-menu`,
  influenceGoal: `${config.url.API_URL}/api/v1/influence-goal/get`,
  //create api
  outComeGoalsCreate: `${config.url.API_URL}/api/v1/outcome-goal/create`,
  influenceGoalsCreate: `${config.url.API_URL}/api/v1/influence-goal/create`,
  // scalerData: `${config.url.API_URL}/api/v1/vv-goal/create`,
  reflectiveGoal: `${config.url.API_URL}/api/v1/reflective-goal/get`,
  getReflactiveQuestion: `${config.url.API_URL}/api/v1/reflective/get`,
  createReflactiveQuestionGole: `${config.url.API_URL}/api/v1/reflective-goal/create`,
  updateOutcomeData: `${config.url.API_URL}/api/v1/outcome-goal/update`,
  updateInfluenceData: `${config.url.API_URL}/api/v1/influence-goal/update`,
  updateReflactiveGole: `${config.url.API_URL}/api/v1/reflective-goal/update`,
  outcomeToInfluece: `${config.url.API_URL}/api/v1/versioning/outcome-to-influence`,
  InflueceToOutcome: `${config.url.API_URL}/api/v1/versioning/influence-to-outcome`,
  InflueceToInfluence: `${config.url.API_URL}/api/v1/versioning/influence-to-influence`,

  // Archive APi's
  getArchiveData: `${config.url.API_URL}/api/v1/journey/get-archive`,
  archiveOutComeData: `${config.url.API_URL}/api/v1/outcome/archive`,
  archiveInfluanceData: `${config.url.API_URL}/api/v1/influence/archive`,
  archiveReflectiveData: `${config.url.API_URL}/api/v1/reflective/archive`,
  deleteArchiveOutComeData: `${config.url.API_URL}/api/v1/outcome/delete`,
  deleteArchiveInfluanceData: `${config.url.API_URL}/api/v1/influence/delete`,
  deleteArchiveReflectiveData: `${config.url.API_URL}/api/v1/reflective/delete`,
  uploadData: `${config.url.API_URL}/api/v1/influence-response/provision-response`,
  uploadAccurateData: `${config.url.API_URL}/api/v1/import-excel/create`,
  exportData: `${config.url.API_URL}/api/v1/influence-response/export`,
  importData: `${config.url.API_URL}/api/v1/influence-response/provision-response`,

  // waitlist
  waitlist_join: `${config.url.API_URL}/api/v1/wait-list/create`,

  // insights
  insightList: `${config.url.API_URL}/api/v1/journey/get-outcome-influence-insights`,
  trendData: `${config.url.API_URL}/api/v1/journey/get-outcome-response-trend`,
  influencetrendData: `${config.url.API_URL}/api/v1/journey/get-influence-response-trend`,
  influenceInsights: `${config.url.API_URL}/api/v1/journey/get-influence-outcome-insights`,
  INSIGHTS: {
    CORRELATIno_MENU: `${config.url.API_URL}/api/v1/journey/get-correlation-menu`,
    Category_Dates: `${config.url.API_URL}/api/v1/journey/get-category-dates`,
    CORRELATIS: `${config.url.API_URL}/api/v1/journey/get-correlation`,
    OUTCOME_CELEBRATION: `${config.url.API_URL}/api/v1/journey/get-outcome-celebration`,
    INFLUENCE_CELEBRATION: `${config.url.API_URL}/api/v1/journey/get-influence-celebration`,
  },
  reports: {
    getAllWeek: `${config.url.API_URL}/api/v1/report/get-all-weeks`,
    getAllWeekReport: `${config.url.API_URL}/api/v1/report/get-week-report`,
  },
  GROUP_CONTACTS: {
    LIST_GROUP: `${config.url.API_URL}/api/v1/group-contact/list`,
    CONTACT_CREATE: `${config.url.API_URL}/api/v1/contact/create`,
    CONTACT_UPDATE: `${config.url.API_URL}/api/v1/contact/update`,
    CONTACT_DELETE: `${config.url.API_URL}/api/v1/contact/delete`,
    GROUP_CREATE: `${config.url.API_URL}/api/v1/group-contact/create`,
    GROUP_UPDATE: `${config.url.API_URL}/api/v1/group-contact/update`,
    GROUP_DELETE: `${config.url.API_URL}/api/v1/group-contact/delete`,
    SHARE_REPORT: `${config.url.API_URL}/api/v1/report/share-report`,
    VIEW_SHARE_REPORT: `${config.url.API_URL}/api/v1/report/view-share-report`,
    GET_REPORT_DETAILS: `${config.url.API_URL}/api/v1/report/get-record-id`,
    GET_REPORTS: `${config.url.API_URL}/api/v1/report/get-records`,
    UPDATE_RECORDS: `${config.url.API_URL}/api/v1/report/update-record`,
    ADD_FEEDBACK: `${config.url.API_URL}/api/v1/report/add-feedback`,
  },
  INTEGRATINS: {
    RESCUE_TIME: {
      UPDATE_RESCUE_TIME_KEY: `${config.url.API_URL}/api/v1/third-party/update-rescue-time`,
      GET_RESCUE_TIME_KEY: `${config.url.API_URL}/api/v1/third-party/get-rescue-time`,
      GET_RESCUE_TIME_DATA: `${config.url.API_URL}/api/v1/third-party/get-data-rescue-time`,
      CREATE_RESCUE_TIME_DATA: `${config.url.API_URL}/api/v1/third-party/create-data-rescue-time`,
      DISCONNECT: `${config.url.API_URL}/api/v1/third-party/disconnect-rescue-time`,
    },
    TOGGL: {
      UPDATE_TOGGL_KEY: `${config.url.API_URL}/api/v1/third-party-toggl/update-toggl-time`,
      GET_TOGGL_KEY: `${config.url.API_URL}/api/v1/third-party-toggl/get-toggl-time`,
      GET_TOGGL_DATA: `${config.url.API_URL}/api/v1/third-party-toggl/get-data-toggl-clients-projects`,
      CREATE_TOGGL_DATA: `${config.url.API_URL}/api/v1/third-party-toggl/create-data-toggl-time`,
      DISCONNECT: `${config.url.API_URL}/api/v1/third-party-toggl/disconnect-toggl`
    },
    OURA: {
      UPDATE_OURA_KEY: `${config.url.API_URL}/api/v1/third-party-oura/update-oura-time`,
      GET_OURA_KEY: `${config.url.API_URL}/api/v1/third-party-oura/get-oura-time`,
      GET_OURA_DATA: `${config.url.API_URL}/api/v1/third-party-oura/get-data-oura-time`,
      CREATE_OURA_DATA: `${config.url.API_URL}/api/v1/third-party-oura/create-data-oura-time`,
      DISCONNECT: `${config.url.API_URL}/api/v1/third-party-oura/disconnect-oura`
    },
    GARMIN: {
      GET_REQUEST_TOKEN: `${config.url.API_URL}/api/v1/third-party-garmin/request-token`,
      GET_GARMIN_KEY: `${config.url.API_URL}/api/v1/third-party-garmin/get-garmin`,
      ACCESS_TOKEN: `${config.url.API_URL}/api/v1/third-party-garmin/access-token`,
      GET_GARMIN_DATA: `${config.url.API_URL}/api/v1/third-party-garmin/get-data-garmin`,
      UPDATE_GARMIN_DATA: `${config.url.API_URL}/api/v1/third-party-garmin/update-keys`,
      DISCONNECT: `${config.url.API_URL}/api/v1/third-party-garmin/disconnect-garmin`
    },
    WHOOP: {
      GET_REQUEST_TOKEN: `${config.url.API_URL}/api/v1/third-party-whoop/request-token`,
      GET_WHOOP_KEY: `${config.url.API_URL}/api/v1/third-party-whoop/get-whoop`,
      ACCESS_TOKEN: `${config.url.API_URL}/api/v1/third-party-whoop/access-token`,
      GET_WHOOP_DATA: `${config.url.API_URL}/api/v1/third-party-whoop/get-data-whoop`,
      UPDATE_WHOOP_DATA: `${config.url.API_URL}/api/v1/third-party-whoop/update-keys`,
      DISCONNECT: `${config.url.API_URL}/api/v1/third-party-whoop/disconnect-whoop`
    },
    GOOGLE_FIT: {
      GET_REQUEST_TOKEN: `${config.url.API_URL}/api/v1/third-party-google-fit/request-token`,
      GET_GF_KEY: `${config.url.API_URL}/api/v1/third-party-google-fit/get-googleFit`,
      ACCESS_TOKEN: `${config.url.API_URL}/api/v1/third-party-google-fit/access-token`,
      GET_WHOOP_DATA: `${config.url.API_URL}/api/v1/third-party-google-fit/get-google-fit-keys`,
      UPDATE_WHOOP_DATA: `${config.url.API_URL}/api/v1/third-party-google-fit/update-keys`,
      DISCONNECT: `${config.url.API_URL}/api/v1/third-party-google-fit/disconnect-googleFit`
    }
  },
  PAYMENT: {
    GET_PRODUCTS: `${config.url.API_URL}/api/v1/payment/get-products`,
    CREATE_CHECKOUT: `${config.url.API_URL}/api/v1/payment/create-checkout`,
    BILLING_PORTAL: `${config.url.API_URL}/api/v1/payment/billing-portal`
  },
  MARKETING: {
    TRAFFIC_SOURCE: `${config.url.API_URL}/api/v1/app/update-traffic-source`
  },
  SETTINGS: {
    HOLIDAY_MODE: `${config.url.API_URL}/api/v1/app/update-holiday-mode`,
    TRACKING_SCHEDULE: `${config.url.API_URL}/api/v1/app/update-user-working-days`,
  },
  ANONYMOUS_USER: {
    GET_ID: `${config.url.API_URL}/api/v1/app/anonymous-id`
  },
  MIX_PANEL: {
    ANONYMOUS: `${config.url.API_URL}/api/v1/app/mixpanel/events-track-anonymous`
  },
  CHATBOT: {
    SUGGESTION_LIST: `${config.url.API_URL}/api/v1/chatbot/list`,
    SUGGESTION_FOLLOW_UP_QUESTION: `${config.url.API_URL}/api/v1/chatbot/handle-flow`,
    NOTIFICATION_PRIORITY: `${config.url.API_URL}/api/v1/chatbot/get-notification-priority`,
  },
};

export const chatBotEndPoint = {
  askQuestion: `${config.url.CHAT_URL}/api/v1/ai/chatbot_avatar`,
  askQuestionV2: `${config.url.CHAT_URL}/api/v1/prediction/b2ae9ca8-ba28-4316-9bee-2d88ef636ef8`,
}